import {useNavigate} from "react-router";
import {useEffect} from "react";
import {clearSavedListParams} from "../../../helpers/LocalStorageHelper";
import {RECORDS_ROUTE} from "../../../routes";

export function RecordsClear() {
    const history = useNavigate()
    useEffect(() => {
        clearSavedListParams();
        history(RECORDS_ROUTE, {replace: true});
    }, []);
    return <div/>
}